import CocoaLandSizeIcon from "../../../assets/icons/cii-indicators/cocoa-land-size.png";
import CocoaYieldIcon from "../../../assets/icons/cii-indicators/cocoa-yield.png";
import CocoaTreeAgeIcon from "../../../assets/icons/cii-indicators/cocoa-tree-age.png";
import HiredLabourDayIcon from "../../../assets/icons/cii-indicators/hired-labour-days.png";
import CostOfHiredLabourIcon from "../../../assets/icons/cii-indicators/cost-of-hired-labour.png";
import FertilizerIcon from "../../../assets/icons/cii-indicators/fertilizer.png";
import PriceIcon from "../../../assets/icons/cii-indicators/price.png";

export const indicatorContent = [
  {
    title: "Cocoa land size",
    icon: CocoaLandSizeIcon,
  },
  {
    title: "Cocoa yield",
    icon: CocoaYieldIcon,
  },
  {
    title: "Cocoa tree age",
    icon: CocoaTreeAgeIcon,
  },
  {
    title: "Cocoa volume",
    icon: CocoaYieldIcon,
  },
  {
    title: "Hired labour days",
    icon: HiredLabourDayIcon,
  },
  {
    title: "Cost of hired labour",
    icon: CostOfHiredLabourIcon,
  },
  {
    title: "Fertilizer cost/hectare",
    icon: FertilizerIcon,
  },
  {
    title: "Price Premium paid/kg",
    icon: PriceIcon,
  },
];
